<template>
    <div class="assistant-message">
        <div v-html="renderedMessage"></div>
    </div>
</template>

<script>
import { marked } from 'marked'

export default {
    name: 'AssistantMessage',
    props: {
        message: {
            type: String,
            required: true
        },
    },
    computed: {
        renderedMessage() {
            // Configure marked for better formatting
            marked.setOptions({
                breaks: true, // Convert line breaks to <br>
                gfm: true,    // Enable GitHub Flavored Markdown
            })
            return marked.parse(this.message)
        }
    }
}
</script>

<style lang="scss" scoped>
.assistant-message {
    display: inline-block;
    background-color: #000;
    max-width: 100%;
    padding: 10px 20px;
    border-radius: 20px;
    color: #e6e6e6;

    // Style the rendered markdown content
    :deep(p) {
        margin: 0 0 10px 0;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        word-break: break-word;
        hyphens: auto;
        line-height: 1.4;

        &:last-child {
            margin-bottom: 0;
        }
    }

    :deep(strong) {
        font-weight: bold;
        color: #fff;
    }

    :deep(em) {
        font-style: italic;
    }

    :deep(ul), :deep(ol) {
        margin: 10px 0;
        padding-left: 20px;
    }

    :deep(li) {
        margin: 5px 0;
        line-height: 1.4;
    }

    :deep(code) {
        background-color: #333;
        padding: 2px 4px;
        border-radius: 3px;
        font-family: 'Courier New', monospace;
    }

    :deep(pre) {
        background-color: #333;
        padding: 10px;
        border-radius: 5px;
        overflow-x: auto;
        margin: 10px 0;
    }

    :deep(blockquote) {
        border-left: 3px solid #666;
        padding-left: 10px;
        margin: 10px 0;
        color: #ccc;
    }
}
</style>
